import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthGuardService } from './services/auth-guard.service';
import { OverviewComponent } from '../overview/overview.component';
import { redirectToCeComponent } from './redirecting-to-netcore-ce/redirect-to-ce.component';
import { CustomerExperienceRequestAccessComponent } from './customer-experience-request-access/customer-experience-request-access.component';
import { OnsiteJourneyComponent } from './onsite-journey/onsite-journey.component';

const routes: Routes = [
  {
    path: 'testgroup-pair',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../pairing-confirmation-webpage/pairing-confirmation-webpage.module').then(m => m.PairingConfirmationWebpageModule)
  },
  {
    path: 'auth',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../loginApp/login-app.module').then(m => m.LoginAppModule)
  },
  {
    path: 'design-components',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../design-components/design-components.module').then(m => m.DesignComponentsModule)
  },
  {
    path: 'overview',
    canActivate: [AuthGuardService],
    component: OverviewComponent
  },
  {
    path: 'actions',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../datasource/datasource.module').then(m => m.DatasourceModule)
  },
  {
    path: 'segments',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../segments/segments.module').then(m => m.SegmentsModule)
  },
  {
    path: 'test-groups',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../test-groups/test-groups.module').then(m => m.TestGroupsModule)
  },
  {
    path: 'settings',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'user-settings',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../settings/user-settings/user-settings.module').then(m => m.UserSettingsModule)
  },
  {
    path: 'app-settings',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../settings/app-settings/app-settings.module').then(m => m.AppSettingsModule)
  },
  /*   {
      path: 'company-settings',
      canActivate: [AuthGuardService],
      loadChildren: '../settings/company-settings/company-settings.module#CompanySettingsModule'
    }, */
  {
    path: 'context-builder/:supportedNudgeType',
    canActivate: [AuthGuardService],
    loadChildren: () => import('../product-journey-manager/product-journey-manager.module').then(m => m.ProductJourneyManagerModule)
  },
  {
    path: 'redirecting-to-netcore-ce',
    canActivate: [AuthGuardService],
    component: redirectToCeComponent
  },
  {
    path: 'ce-request-access',
    canActivate: [AuthGuardService],
    component: CustomerExperienceRequestAccessComponent
  },
  {
    path: 'onsite-journey',
    canActivate: [AuthGuardService],
    component: OnsiteJourneyComponent
  },
  /*  {
     path: 'user-management',
     canActivate: [AuthGuardService],
     loadChildren: '../user-management/user-management.module#UserManagementModule'
   }, */
  {
    path: '**',
    redirectTo: 'overview'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
